import type { IInsertData, IMaskPanel, TInsertionListener } from "../Header.ts";

/**
 * Base class for mask panels with a few default implementations. The following
 * methods are not implemented and must be overridden:
 * - close
 * - open
 * - update
 * - isOpen
 */
export abstract class AbstractMaskPanel implements IMaskPanel {
  protected _insertionListener: TInsertionListener;

  constructor() {
    this._insertionListener = () => undefined;
  }

  focused(): void {
    // no-op by default
  }

  async getSelectedValue(): Promise<IInsertData | undefined> {
    return undefined;
  }

  onExternalChange(): void {
    // no-op by default
  }

  setInsertionListener(insertionListener: TInsertionListener): void {
    this._insertionListener = insertionListener;
  }

  abstract close(): void;

  abstract isOpen(): Promise<boolean>;

  abstract open($position: JQuery): void;

  abstract update(): void;
}

/**
 * No-op implementation of a mask panel.
 */
export class NoOpMaskPanel extends AbstractMaskPanel implements IMaskPanel {
  override close(): void {
    // no-op by default
  }

  override async isOpen(): Promise<boolean> {
    return false;
  }

  override open(): void {
    // no-op by default
  }

  override update(): void {
    // no-op by default
  }
}
